import { requests } from "../index";
import URLS from "../endPoints";
import request from "superagent";

import axios from "axios";

let Story = {};
// Story.AddStory = async (payload) =>
//   await requests.post(URLS.magUrl.insertStory, payload);

// Story.GetAllStory = async () => await axios.get("http://localhost:3001/Career/GetAllStories");
Story.GetAllStory = async (CANID) => await requests.get(URLS.magUrl.getallStory) //api call
export default Story;
